exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-043e43b6] .uploader-btn,[data-v-043e43b6] .uploader-drop{background-color:var(--contentBgColor)}[data-v-043e43b6] .uploader-btn{border:1px dashed var(--lineBorderColor);border-radius:6px}[data-v-043e43b6] .uploader-btn:hover{border-color:var(--uploadHoverColor)}", ""]);

// exports
